/**
 * @generated SignedSource<<7ebe2671d9072fefb371c354db7659fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Plugin_charge$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Order_charge">;
  readonly " $fragmentType": "Plugin_charge";
};
export type Plugin_charge$key = {
  readonly " $data"?: Plugin_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"Plugin_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Plugin_charge",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Order_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "5f30683dd48beed148ddae982ef3a331";

export default node;
